// extracted by mini-css-extract-plugin
export default {"wrapper":"Demo_wrapper__MSZ-H"};